import React, { useContext, useState } from "react";
import { Navbar, Container } from "react-bootstrap";
import { 
  styled, 
  Typography, 
  IconButton, 
  Button 
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from "react-router-dom";
import { Context } from "../../context/DataProvider";
import ProfileImg from "../utils/images/profile.svg";
import "../utils/css/NavBar.css";
import { isMobile } from "../utils/miscutils";
import { ACCESSIBILITY_LABELS } from "../../config/constants";
import {isWebView} from "../utils/deviceUtils"
import {useTaskDeviceBridge} from "@docsapp/native-wizard-sa/src/lib/useTaskDeviceBridge"
import PolicySelectionDialog from "./PolicySelectionDialog";
import {handleKeyboardClick} from "../../utils/keyboardUtils";

const Styleimg = styled("img")({
  width: 175,
  height: 35,
});

export default function NavBar(props) {
  const navigate = useNavigate();
  const taskDeviceBridge = useTaskDeviceBridge();
  const [showMenu, setShowMenu] = useState(false);
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  
  const {
    setFlag,
    userPoliciesCtx,
    selectedPolicyIdCtx,
    setSelectedPolicyIdCtx,
  } = useContext(Context);
  const uname = props.userName;


  const clickHapticFeedback = async () => {
		try {
			await taskDeviceBridge.getHapticFeedBack("CLICK");
		} catch (error) {
			console.error("Haptic feedback error:", error);
		}
	};


 const goTo = async () => {
    setFlag(false);
    document.activeElement?.blur?.();
    if (isWebView() && props.isLandingPage) {
      try {
          await clickHapticFeedback();
          taskDeviceBridge.popBack(true); 
        } catch (error) {
          console.error("Error using native navigation:", error);
          await clickHapticFeedback();
          navigate(-1);
        }
    } else {
      await clickHapticFeedback();
      navigate(-1);
    }
  };

  const selectedPolicyLabel =
    userPoliciesCtx.find((p) => p?.entityPolicyId == selectedPolicyIdCtx)?.policyPeriodLabel
    || userPoliciesCtx.find((p) => p?.entityPolicyId == selectedPolicyIdCtx)?.policyName;


  const handleMobilePolicyChange = (policyId) => {
    setSelectedPolicyIdCtx(policyId);
    localStorage.setItem("entityPolicyId", policyId);
    setShowPolicyModal(false);
  };

  const handleOpenPolicyModal = () => {
    setShowPolicyModal(true);
  };

  const handleClosePolicyModal = () => {
    setShowPolicyModal(false);
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="topBar">
        <Navbar bg="white" expand="lg" fixed="top" title="Medibuddy Navbar">
          <Container>
            <div
              className="reimbursementLogo"
              tabIndex={"0"}
              onKeyDown={handleKeyboardClick(() => window.location.href = "https://www.medibuddy.in")}
            >
              <Navbar.Brand href="https://www.medibuddy.in">
                <Navbar aria-label={ACCESSIBILITY_LABELS.NAVIGATION.MEDIBUDDY_LOGO}>
                  <Styleimg
                    src="https://www.medibuddy.in/assets/logos/medibuddyWithName.svg"
                    alt="Medibuddy - Digital Healthcare"
                  />
                </Navbar>
              </Navbar.Brand>
            </div>
            {uname ? (
              <div
                role="button"
                onClick={() => setShowMenu((val) => !val)}
                className="user-profile-wrap"
                tabIndex={"0"}
                onKeyDown={handleKeyboardClick(() => setShowMenu((val) => !val))}
              >
                <img src={ProfileImg} alt={`${uname} profile menu`} />
              </div>
            ) : (
              <></>
            )}
            {showMenu ? (
              <div className="menu-wrapper">
                <div
                  className="menu-item"
                  tabIndex={showMenu ? "0" : undefined}
                >
                  {uname}
                </div>
              </div>
            ) : (
              <></>
            )}
          </Container>
        </Navbar>
      </div>

      <div className="secondBar">
        {isMobile(window.innerWidth) ? (
          <div className="secondBar-mobile">
            <div className="mobile-header-bar">
              <IconButton aria-label={ACCESSIBILITY_LABELS.NAVIGATION.GO_BACK} onClick={goTo}>
                <ArrowBackIcon sx={{ color: "#252D38" }} fontSize="22px" />
              </IconButton>

              <Typography
                component="h1"
                className="mobile-header-title"
                tabIndex="0"
              >
                Reimbursement
              </Typography>

              {userPoliciesCtx?.length > 0 ? (
                <Button
                  variant="outlined"
                  onClick={handleOpenPolicyModal}
                  className="mobile-policy-toggle"
                  aria-label={ACCESSIBILITY_LABELS.POLICY.SWITCH_POLICY_MOBILE(selectedPolicyLabel)}
                  aria-haspopup={ACCESSIBILITY_LABELS.ARIA_HASPOPUP.DIALOG}
                  sx={{
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #DBE0E6",
                    borderRadius: "8px",
                    padding: "10px 16px",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#252D38",
                    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                    width: "200px",
                    overflow: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "4px",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#F9FAFB",
                      border: "1px solid #DBE0E6",
                    },
                    "& .MuiButton-startIcon": {
                      margin: 0,
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#252D38",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      flex: 1,
                      textAlign: "left",
                    }}
                  >
                    {selectedPolicyLabel || "Select Policy"}
                  </Typography>
                  <ExpandMoreIcon
                    aria-hidden="true"
                    sx={{
                      color: "#252D38",
                      paddingLeft: "5px",
                      fontSize: "23px",
                    }}
                  />
                </Button>
              ) : (
                <div style={{ width: 140 }} />
              )}
            </div>
            <PolicySelectionDialog
              open={showPolicyModal}
              onClose={handleClosePolicyModal}
              policies={userPoliciesCtx}
              selectedPolicyId={selectedPolicyIdCtx}
              onPolicyChange={handleMobilePolicyChange}
            />
            <div className="secondBar-divider" />
          </div>
        ) : (
          <hr />
        )}
      </div>
    </div>
  );
}